module.exports = __webpack_public_path__ + "img/warning.8148959f.png";